// extracted by mini-css-extract-plugin
module.exports = {"circular_progress":"CircularProgress_circular_progress__1mSZP","spin":"CircularProgress_spin__2jNud","centered":"CircularProgress_centered__1eUs6"};